'use client';

import { useSyncExternalStore } from 'react';

import { Observable } from './observable.state.service';

/**
 * Subscribes a component to an observable.
 *
 * Built on `useSyncExternalStore` so the value is read consistently within a
 * render and so the server-rendered HTML can be hydrated without mismatch:
 * during hydration React reads {@link Observable.getServerSnapshot}, the same
 * value the server rendered, and only then re-renders with the live one.
 */
export const useObservable = <T>(observable: Observable<T>): T | undefined =>
  useSyncExternalStore(observable.subscribe, observable.get, observable.getServerSnapshot);
